import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { Footer } from "../../../components/Landing/Footer";
import '../PeopleList.scss';
import segundaDesktop from "../../../assets/pp/BANNER CIC.png";
import banner2 from "../../../assets/pp/Banner-cic-1-agenda.jpg"
import banner3 from "../../../assets/pp/Banner-cic-2-agenda.jpg"
const botonCronograma = process.env.PUBLIC_URL + encodeURI("/assets/pp/Cronograma.jpg");
// style
import "../landing.style.scss";
import { CarouselCustom } from "../components/Carousel/CarouselCustom";

export const PpCic = () => {

  return (
    <div>
      <Header />
      <HeaderPp />
      <CarouselCustom
        images={[
          { src: segundaDesktop, alt: "Banner 1" },
          { src: banner2, alt: "Banner 2" },
          { src: banner3, alt: "Banner 3" },
        ]}
      />
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
          <strong>
            <h1 className="mb-5" style={{color: '#1e3a53'}}>
              CIC
            </h1>
          </strong>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            Es la programación de encuentros y eventos ciudadanos de arte y cultura para la promoción y proyección de las expresiones culturales y del talento artístico de cada comuna y corregimiento del Distrito, que permite y fomenta el acceso y disfrute por parte de los habitantes del respectivo territorio.
          </h4>
        </div>
      </div>
      <br />
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
              <strong>
                <h1 className="mb-5" style={{color: '#1e3a53'}}>
                  ¿Qué es el CIC?
                </h1>
              </strong>
              <div style={{padding: '20px', backgroundColor: '#1e3a53', borderRadius: '10px'}}>
                <h4 className="mb-3" style={{textAlign: 'justify', marginTop: '10px', color: 'white'}}>
                  El CIC es una iniciativa creada en el contexto del Distrito de Ciencia, Tecnología e Innovación de Medellín, surgió a partir del programa de Planeación para el Desarrollo Local y Presupuesto Participativo (PDL y PP), con el objetivo de desarrollar y fortalecer la investigación cultural en las diferentes comunas de la ciudad. El CIC integra los conceptos de investigación y cultura, ambos con múltiples significados e interpretaciones.
                </h4>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
              <strong>
                <h1 className="mb-5" style={{color: '#1e3a53'}}>
                  Nuestro objetivo
                </h1>
              </strong>
              <div style={{padding: '20px', backgroundColor: '#1e3a53', borderRadius: '10px'}}>
                <h4 className="mb-3" style={{textAlign: 'justify', marginTop: '10px', color: 'white'}}>
                  Implementar Centros de Investigación Cultural que respondan a las políticas establecidas por la Secretaría de Cultura Ciudadana del Distrito Especial de Ciencia, Tecnología e Innovación de Medellín, con el fin de fortalecer la investigación, la innovación y la promoción cultural en la región.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={botonCronograma}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">CRONOGRAMA</h3>
                  <p className="card2-description">
                    Te invitamos a conocer la programación de los próximos laboratorios de Co-Creación que hay en tu comuna para que nos acompañes y hagas parte de la investigación cultural que se lleva a cabo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="video-section">
        <div className="video-wrapper">
          <div className="video-frame">
            <iframe
              src="https://drive.google.com/file/d/1JSVSP611c4swqrW3rr5kgXi4u8VUawel/preview"
              allow="autoplay"
              allowFullScreen
              loading="lazy"
              title="Video"
            ></iframe>
          </div>
          <div className="video-text">
            <h2>¿Por qué ser parte de la Convocatoria de Estímulos 2025?</h2>
            <p>
            Este video te muestra cómo tu creatividad puede transformar la ciudad. Escucha las voces que ya han hecho parte de esta experiencia y descubre por qué tu proyecto también puede marcar la diferencia.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
